import { render } from "./activitynotice.vue?vue&type=template&id=fb400f1a&scoped=true"
import script from "./activitynotice.vue?vue&type=script&lang=js"
export * from "./activitynotice.vue?vue&type=script&lang=js"

import "./activitynotice.vue?vue&type=style&index=0&id=fb400f1a&scoped=true&lang=css"

import exportComponent from "/Users/jx/project/wld/nongxin-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb400f1a"]])

export default __exports__